import { Col, Row } from "react-bootstrap";
import InputSubmit from "../Input/InputSubmit";
import fistImage from "../../../static/images/fist.png";
import { useStateValue } from "../../../store/StateProvider";
import constants from "../../../config/constants";

const SuccessPage = () => {
  const [{ formValues, successPageConfig }] = useStateValue();
  const replaceTextDescription = (text, replacements) => {
    let result = text;
    if (replacements && typeof replacements === "object") {
      Object.entries(replacements).forEach(([replaceKey, valueKeys]) => {
        const validKey = valueKeys.find(valueKey => formValues[valueKey] != null && formValues[valueKey] !== "");
        result = result.replaceAll(replaceKey, formValues[validKey] ?? "");
      });
    }
    return result;
  };

  const handleClick = e => {
    e.preventDefault();
    window.open(successPageConfig.buttonLink, "_blank", "noopener,noreferrer");
  };

  const getDescription = () => {
    if (successPageConfig?.description == null) {
      return (
        <p className="sub_title">
          {replaceTextDescription(
            constants.SUCCESS_PAGE_DEFAULT_SUBTITLE,
            constants.SUCCESS_PAGE_DEFAULT_SUBTITLE_REPLACED
          )}
        </p>
      );
    }

    if (!Array.isArray(successPageConfig.description)) {
      return (
        <p className="sub_title">
          {replaceTextDescription(successPageConfig.description, successPageConfig.textReplacedFromForm)}
        </p>
      );
    }

    return successPageConfig.description.map(paragraph => (
      <p className="sub_title">{replaceTextDescription(paragraph, successPageConfig.textReplacedFromForm)}</p>
    ));
  };

  return (
    <section className="content">
      <Row>
        <Col>
          <div className="content_box_centered success-container">
            <div className="success-page">
              <div className="title_image success-img">
                <img className="bullet_img" alt="ok" src={fistImage} />
                &nbsp;
              </div>
              <h3 className="success-title">{successPageConfig?.title ?? constants.SUCCESS_PAGE_DEFAULT_TITLE}</h3>
              <div>{getDescription()}</div>
              {successPageConfig?.buttonShow && (
                <div className="button_container">
                  <InputSubmit
                    fieldConfig={{
                      name: "Submit",
                      default: successPageConfig?.buttonText,
                      onClick: successPageConfig?.buttonLink ? handleClick : undefined
                    }}
                    className="success-btn"
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default SuccessPage;
